export const setResponseMessage = {
  SET_RESPONSE_MESSAGE(state, { message, type }) {
    state.responseMessage = {
      message,
      type
    };
  }
};
